import { render, staticRenderFns } from "./GitHubOAuthCallback.vue?vue&type=template&id=ec2931e2&scoped=true&"
import script from "./GitHubOAuthCallback.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GitHubOAuthCallback.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GitHubOAuthCallback.vue?vue&type=style&index=0&id=ec2931e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2931e2",
  null
  
)

export default component.exports